// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { stockApi } from '../../lib/api';
import { type Stock } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/stock/';

export default (props: PageProps) => {
  const [data: Stock, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await stockApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: Stock) => {
    let id = payload.id;
    if (id) {
      await stockApi.update(payload);
    } else {
      await stockApi.add(payload);
    }
    await navigate(`${entryPointPath}`, true);
  };

  const onCancel = async (payload: Stock) => {
    await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Склады'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
